import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { data } from 'autoprefixer'

// create an axios instance
const baseurl = 'http://www.autof.cn:8888'
const service = axios.create({
  baseURL: baseurl, // url = base url + request url
  headers: { 'Content-Type': 'multipart/form-data; charset=utf-8' },
  // timeout: 5000, // request timeout
})

// response interceptor 返回拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 接口返回值ret为0成功
    if (response.config.url.includes('/fsl/download')) {
      return res
    }
    if (res.ret !== '0') {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      // 成功返回数据
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 文件下载
export function download () {
  return service({
    url: '/fsl/download.do',
    method: 'get'
  })
}

// 文件上传替换
export function upload (data) {
  return service({
    url: '/fsl/upload.do',
    method: 'post',
    data
  })
}

// 文件删除
export function delfile (data) {
  return service({
    url: '/fsl/delfile.do',
    method: 'post',
    data
  })
}

// 返回上传文件的url
export function uploadUrl (fid) {
  return `${baseurl}/fsl/download.do?fid=${fid}`
}

export async function uploadResult (obj, fid) {
  try {
    return new Promise((resolve) => {
      let fd = new FormData();
      fd.append('file', obj.file);
      if (fid) {
        // 已上传删除该fid
        delfile({ fid: fid });
      }
      upload(fd).then(data => {
        resolve({
          fid: data.fid,
          url: uploadUrl(data.fid),
          name: obj.file.name
        });
      });
    });
  }
  catch (error) {
    reject(error);
  }
}

// 富文本上传
export function uploadEditor (content) {
  return service({
    url: '/fsl/uploadtext.do?ext=html',
    method: 'post',
    data: content
  })
}

// 富文本更新
export function updateEditor (fid, content) {
  return service({
    url: `/fsl/uploadtext.do?ext=html&fid=${fid}`,
    method: 'post',
    data: content
  })
}

// 获取富文本内容
export function getEditorContent (id) {
  return service({
    url: `/fsl/download.do?fid=${id}&${Math.random()}`,
    method: 'get',
  })
}
